// extracted by mini-css-extract-plugin
export var pColumn2 = "vh";
export var animationMarquee = "wh";